module.exports = __webpack_public_path__ + "img/small_arrow.ae449277.svg";